import { EyeOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Links } from '../../helpers/Links';
import { dateCommon } from '../../helpers/common';
import { NguoiDungResponse } from '../../models/nguoidung/NguoiDung';
import { layThongTinCaNhan } from '../../services/nguoidung';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const ThongTinCaNhan = () => {
    const [data, setData] = useState<NguoiDungResponse>(new NguoiDungResponse);
    const user = useSelector((state: any) => state.auth.currentUser);
    const dispatch = useDispatch();
    const layDuLieu = async () => {
        dispatch(showLoadingScreen());
        try {
            let kq = await layThongTinCaNhan();
            setData(kq);
            dispatch(hideLoadingScreen());
        } catch (err) {
            dispatch(hideLoadingScreen());
        }
    }
    useEffect(() => {
        layDuLieu();
    }, []);

    return (
        <Row>
            <Col span="24">
                <div className="card-outline">
                    <div className="tab-content mx-5">
                        <Row>
                            <Col span={8}>
                                <div className="mb-1">
                                    <div>Tên đăng nhập</div>
                                    <label>{data?.tenDangNhap}</label>
                                </div>
                                <div>
                                    <div>Họ tên</div>
                                    <label>{user.isAdmin ? "Quản trị hệ thống" : data.hoTen}</label>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div className="mb-1">
                                    <div>Đơn vị</div>
                                    <label>{user.isAdmin ? "": data?.tenDonVi}</label>
                                </div>
                                <div>
                                    <div>Ngày sinh</div>
                                    <label>{dateCommon.formatDate(data.ngaySinh)}</label>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div>
                                    <div>Số điện thoại</div>
                                    <label>{user.isAdmin ? "02363888769" : data.dienThoai}</label>
                                </div>
                                <div>
                                    <div>Email</div>
                                    <label>{user.isAdmin ? "ddif@danang.gov.vn" : data.email}</label>
                                </div>
                            </Col>
                        </Row>
                        <Link className="hrm-btn btn-primary float-right" 
                            to={Links.NhanVien.HoSoCaNhan}>
                            <EyeOutlined rev='' />
                            Xem hồ sơ cá nhân
                        </Link>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default ThongTinCaNhan;
